import { SET_TOKEN } from './../const';

function action(token, context, lang) {
  return { type: SET_TOKEN, token, context, lang };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/commons/set_token.js